import styled from 'styled-components';
import { Link as LinkRouter } from 'react-router-dom';
import { Link as LinkScroll } from 'react-scroll';

import logo from 'assets/icons/cryptocurrency.svg';

const Nav = styled.nav`
  background: ${({ scrollNav }) => (scrollNav ? '#101010' : 'transparent')};
  height: 80px;
  /* margin-top: -80px;  // transparent background */
  font-size: 1rem;

  display: flex;
  justify-content: center;
  align-items: center;

  /* position: sticky;
  top: 0;
  z-index: 10;  */

  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10;

  @media (max-width: 960px) {
    transition: var(--transition);
  }
`;

const NavbarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  height: 80px;
  z-index: 1;
  width: 100%;
  padding: 0 24px;
  max-width: 1100px;
`;

const NavLogo = styled(LinkRouter)`
  justify-self: flex-start;
  cursor: pointer;

  display: flex;
  align-items: center;
  margin-left: 1.5rem;
  font-weight: bold;
  text-decoration: none;
  font-size: 1.25rem;
  text-transform: uppercase;

  background: linear-gradient(to right, #01bf71, #9f2fff);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const LogoImage = styled.img.attrs({
  src: logo,
  alt: 'logo'
})`
  max-width: 50px;
  margin-right: 20px;
`;

const MobileIcon = styled.div`
  display: none;

  @media (max-width: 768px) {
    color: #fff;
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-100%, 60%);
    font-size: 1.8rem;
    cursor: pointer;
  }
`;

const NavMenu = styled.ul`
  display: flex;
  align-items: center;

  text-align: center;
  list-style: none;
  margin-right: -22px; // because of contact button

  @media (max-width: 768px) {
    display: none;
  }
`;

const NavItem = styled.li`
  height: 80px; // because parent is flex we have to add the same height as nav
`;

const NavLink = styled(LinkScroll)`
  display: flex;
  align-items: center;

  color: #fff;
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  text-decoration: none;

  height: 100%; // because of parent height to be the same
  padding: 0 1rem;

  transition: var(--transition);
  cursor: pointer;

  &:hover {
    color: var(--color-primary);
    transition: var(--transition-hover);
  }

  &.active {
    // qool litle trick for active scroll class
    border-bottom: 3px solid #01bf71;
  }
`;

const NavButton = styled.li`
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    display: none;
  }
`;

export {
  Nav,
  NavbarContainer,
  NavLogo,
  LogoImage,
  MobileIcon,
  NavMenu,
  NavItem,
  NavLink,
  NavButton
};
